<template>
  <div>
      <table class="table table-striped action-tracker-table">
        <thead>
        <tr>
          <th class="ac-col-2">
            Business Key

          </th>
          <th class="ac-col-5">
            Question Action
          </th>
          <th class="ac-col-225">
            Your Answer
          </th>
          <th>
            Status
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(answer, index) in answers">
          <tr v-if="!isTrial || index < 3" v-on:click="$emit('onEditAnswer', answer.question_id)" :key="answer.id">
            <th scope="row ">
              <p>{{ answer.parent }}</p>
              <span>{{ answer.section }}</span>
            </th>
            <td>
              <p>{{ answer.question }}</p>
            </td>
            <td>
              <p> {{ answer.answer }}</p>
              <span class="answer-data">{{formatDate(answer.created_at, answer.updated_at)}}</span>
            </td>
            <td>
              <div class="status-container">
                <div v-if="checkCorrectlyAnsweredStatus(answer)">
                  <span class="status-track status-marks-completed"><i class="far fa-check"></i> Correctly Answered</span>
                </div>
                <div v-else>
                  <p>Target Remedy<br />{{ formatTargetRemedyDate(answer.target_remedy) }} </p>
                  <span class="status-track" :class="getStatusClass(answer.status)">{{ answer.status }}</span>
                </div>
                <i v-if="answer.notes + answer.auditor_notes > 0" class="fal fa-file-edit"></i>
                <i v-if="answer.documents > 0" class="fal fa-files"></i>
                <i v-if="answer.checkpoints > 0" class="fa fa-check-square-o"></i>
                <i v-if="answer.archived === 1" class="fa fa-archive"></i>
              </div>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
  </div>
</template>

<script>
export default {
  props: ['answers', 'severityGroups', 'severityLabels', 'selectedFilters', 'sortColumn', 'sortDir', 'showCompleted', 'completedCount', 'isTrial'],
  data() {
    return {
      currentSortActiveDirection: 'active fa-sort-desc',
    }
  },
  watch: {
    sortDir: function(newVal, oldVal) {
      this.currentSortActiveDirection = newVal == 'desc' ? 'active fa-sort-desc' : 'active fa-sort-asc';
    },
  },
  methods: {

    formatDate: function (created_at, updated_at) {
      let date = null;
      if (created_at || updated_at) {
        if (created_at) {
          date = created_at;
        } else {
          date = updated_at;
        }
        date = moment(date, "YYYY-MM-DD h:imm:ss").format("DD.MM.YYYY");
      }

      return date;
    },
    formatTargetRemedyDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
    },
    getStatusClass: function (status) {
      if (status == 'On Track') return 'status-marks-on-track';
      if (status == 'Delayed') return 'status-marks-delayed';
      if (status == 'Severely Delayed') return 'status-marks-severely-delayed';
      if (status == 'Completed') return 'status-marks-completed';
    },

    checkCorrectlyAnsweredStatus(answer){
      return answer.initially_correct ?? false;
    },
  }
}
</script>